import { render, staticRenderFns } from "./BeehiveLogo.vue?vue&type=template&id=0d4a0b9f"
import script from "./BeehiveLogo.vue?vue&type=script&lang=ts"
export * from "./BeehiveLogo.vue?vue&type=script&lang=ts"
import style0 from "./BeehiveLogo.vue?vue&type=style&index=0&id=0d4a0b9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports